import Vue from 'vue';
import axios from 'axios';

const SET_ITEMS = async (state, obj) => {
  state.items = obj.data;
  
  // Loop para percorrer cada item (receivable)
  for (let i = 0; i < state.items.length; i++) {
    let receivable = state.items[i]; // Acessa o receivable atual pelo índice
    // Verificando se o receivable tem um invoice_id e se o status não foi atualizado
    if (receivable.invoice_id && !receivable.invoice_issued) {
      try {
        // Fazendo a requisição para consultar o status do invoice
        const response = await axios.post(`/financial/invoices/${receivable.invoice_id}/consult_invoice/`);

        // Supondo que o status retornado seja um campo "status" na resposta
        const invoiceStatus = response.data.status; // Ajuste conforme a resposta real

        // Atualizando o campo invoice_issued com base no status
        // Exemplo: se o status for "Emitida", então invoice_issued será true
        receivable.invoice_issued = invoiceStatus === 'Emitida'; // Isso pode variar de acordo com a lógica de status
        await axios.post(`/financial/receivable/${receivable.pk}/update_invoice_issued/`, {invoice_issued: receivable.invoice_issued})
        
        // Usando Vue.set ou Vue.set para garantir que a mudança seja reativa
        Vue.set(state.items, i, { ...receivable }); // Atualiza o receivable de maneira reativa

      } catch (error) {
        console.error('Erro ao consultar o status do invoice:', error);
        // Caso ocorra erro, definimos invoice_issued como false
        receivable.invoice_issued = false;
        // Usando Vue.set ou Vue.set novamente para garantir reatividade
        Vue.set(state.items, i, { ...receivable });
      }
    } else if (!receivable.invoice_id) {
      // Caso não tenha invoice_id, você pode definir invoice_issued como false
      receivable.invoice_issued = false;
      Vue.set(state.items, i, { ...receivable });
    }
  }

  state.perPage = obj.perPage || 15;
  state.page = obj.page;
  state.total = obj.total;
};

const ADD_ITEM = (state, obj) => {
  state.items = [obj, ...state.items];
};

const EDIT_ITEM = (state, obj) => {
  const items = [...state.items];
  const index = items.findIndex(p => p.pk == obj.pk);
  items[index] = { ...obj };
  state.items = items;
};

const DELETE_ITEM = (state, obj) => {
  state.items = state.items.filter(p => p.pk !== obj.pk);
};

export default {
  SET_ITEMS,
  ADD_ITEM,
  EDIT_ITEM,
  DELETE_ITEM
};
